<template>
  <div v-if="products">
    <div class="summary-results">
      <div class="container-fluid">
        <div class="row align-items-center">
          <div
            class="col-12 col-md-6 center-cover image-col d-none d-md-block"
            v-bind:style="{'background-image': `url(${settings.background_url_1})`}"
          ></div>
          <div class="image-block-sm d-block d-md-none">
            <img :src="settings.background_url_1" />
          </div>
          <div class="col-12 col-md-6 summary-col paragraph">
            <h1 class="mb-4 d-block summary-result-text">{{ texts.yourResultText }}</h1>
            <p class="mb-3 mb-sm-5">
              {{ data.skin_type.userTellingText || '' }}
            </p>
            <p class="mb-3 d-block">{{ texts.discountDescriptionText }} </p>
            <div class="discount-code left">
              <div class="wrapper m-auto">
                <div class="float-left discount-code-col">
                  <span class="btn with-code btn-secondary full b-4">
                    {{discountCode}}
                  </span>
                </div>
                <div class="float-left discount-code-col">
                  <span
                    :class="`
                      btn btn-primary btn-buy mr-3 mb-0 mb-md-3
                      ${discountCodeCopied ||discountCodestatus ? 'copied' : ''}
                    `"
                    v-clipboard:copy="discountCode"
                    v-clipboard:success="clipboardSuccess"
                  >
                    {{
                    discountCodeCopied
                      ? texts.copied
                      : (discountCodestatus ? texts.consumed : texts.copy)
                    }}
                  </span>
                </div>
              </div>
            </div>
            <span class="discount-code-text text-left">
              {{ texts.discountDisclaimer }}
            </span>
          </div>
        </div>
        <div class="row align-items-center flex-md-row flex-column-reverse">
          <div class="col-12 col-md-6 summary-col paragraph">
            <h1 class="mb-4">{{ data.skin_type ? data.skin_type.value : '' }}</h1>
            {{ data.skin_type ? data.skin_type.description : '' }}
          </div>
          <div
            class="col-12 col-md-6 center-cover image-col d-none d-md-block"
            v-bind:style="{'background-image': `url(${settings.background_url_2})`}"
          ></div>
          <img class="d-block d-md-none" :src="settings.background_url_2" />
        </div>
      </div>
    </div>
    <div class="your-scincare">
      <div class="jumbotron text-center">
        <h2 v-if="products.length > 0" class="mb-0">{{ texts.yourSkincareRoutine}}</h2>
      </div>
      <div class="products">
        <div class="container-fluid">
          <div class="product" v-for="product in products" :key="product.name">
            <div class="row align-items-center">
              <div
                class="col-12 col-md-6 image-col d-md-flex
                d-none align-items-center justify-content-center"
              >
                <div>
                  <img :src="product.thumbnail" />
                </div>
              </div>
              <div class="col-12 col-md-6 product-info-col">
                <div class="p-4 p-md-0">
                  <h2 class="mb-3">
                    <span>{{product.product_type}}</span>
                  </h2>
                  <p class="product-description mb-0 mb-md-5">{{ product.description }}</p>
                </div>
                <div class="image-sm d-md-none d-flex justify-content-center">
                  <div>
                    <img :src="product.thumbnail" />
                  </div>
                </div>
                <div class="d-flex flex-column pl-4 pl-md-0 pr-4 pr-md-0 pt-4 pt-md-0 pb-2 pb-md-0">
                  <span class="product-category font-weight-bold">
                    {{ product.brand }}
                  </span>
                  <span class="product-title mb-2 font-weight-normal">{{ product.name }}</span>
                  <span
                    :class="`
                      product-price mb-0
                      ${Number(product.sale_price) && 'on-sale' }
                      ${!Number(product.rek_price) && 'mb-md-4' }
                    `"
                  >
                    <span v-if="Number(product.sale_price)" class="sale-price mr-1">
                      {{ product.sale_price }} {{ texts.currency }}
                    </span>
                    <span>{{ product.price }} {{ texts.currency }}</span>
                  </span>
                  <span v-if="Number(product.rek_price)" class="rek-price mb-0 mb-md-4">
                    {{texts.recPrice}} {{ product.rek_price }} {{ texts.currency }}
                  </span>
                </div>
                <div class="d-flex align-items-center flex-wrap p-4 p-md-0">
                  <span
                    v-if="product.is_out_of_stock"
                    class="pr-3 out-of-stock-hero out-of-stock mb-2"
                  >
                    {{ texts.noMoreProducts }}
                  </span>
                  <button
                    v-if="!product.is_out_of_stock"
                    @click="addToCart(product.sku)"
                    class="btn btn-primary btn-buy mr-3 mb-0 mb-md-3"
                  >{{ texts.buy }}</button>
                  <a
                    :href="product.url"
                    target="_top"
                    class="btn btn-secondary btn-sm mr-0 mr-sm-3 mb-0 mb-md-3"
                  >{{ texts.readMore }}</a>
                </div>
              </div>
            </div>
            <div class="d-md-none d-block pl-2 pr-2 mt-3">
              <hr class="separator" />
            </div>
          </div>
        </div>
      </div>
      <div class="jumbotron sale">
        <div class="container" v-if="products.length">
          <h3
            class="mb-3 text-center"
          >
            {{ texts.discountDescriptionText }}
          </h3>
          <div class="discount-code">
            <div class="wrapper m-auto">
              <div class="float-left discount-code-col">
                <span class="btn with-code btn-secondary full b-4">
                  {{discountCode}}
                </span>
              </div>
              <div class="float-left discount-code-col">
                <span
                  :class="`
                    btn btn-primary btn-buy mr-3 mb-0 mb-md-3
                    ${discountCodeCopied ||discountCodestatus ? 'copied' : ''}
                  `"
                  v-clipboard:copy="discountCode"
                  v-clipboard:success="clipboardSuccess"
                >
                  {{
                    discountCodeCopied
                      ? texts.copied
                      : (discountCodestatus ? texts.consumed : texts.copy)
                  }}
                </span>
              </div>
            </div>
          </div>
          <span class="discount-code-text">
            {{ texts.discountDisclaimer }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'loginregistration',
  components: {},
  data() {
    return {
      settings: {
        background_url_1:
          'https://bangerhead-test-api.s3.eu-north-1.amazonaws.com/media/summary_1.jpg',
        background_url_2:
          'https://bangerhead-test-api.s3.eu-north-1.amazonaws.com/media/summary_2.jpg',
      },
      texts: {},
      products: null,
      discountCode: 'Loading',
      discountCodeCopied: false,
      discountCodestatus: false,
      sendingCartAddRequest: false,
      webiste_base: this.WEBSITE_BASE,
    };
  },
  methods: {
    returnCorrectLangDomain() {
      const { lang } = this.$route.query;
      if (lang.toLowerCase() === 'no') return 'https://www.bangerhead.no';
      if (lang.toLowerCase() === 'fi') return 'https://www.bangerhead.fi';
      if (lang.toLowerCase() === 'dk') return 'https://www.bangerhead.dk';
      return 'https://www.bangerhead.se/';
    },
    async addToCart(item) {
      this.sendingCartAddRequest = true;
      let products = [item];
      if (item === 'all') {
        products = [];
        await this.products.forEach(async (el) => {
          products.push(el.sku);
        });
      }

      const { id } = this.data.form.form;

      this.$http
        .post(
          'api/cart/add/',
          {
            products,
            id,
          },
          {
            headers: {
              Authorization: this.token,
            },
          },
        )
        .then(response => response.data)
        .then(() => {
          window.parent.postMessage('addToCart', this.returnCorrectLangDomain());
        });
    },
    clipboardSuccess() {
      this.discountCodeCopied = true;
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  async mounted() {
    const { lang } = this.$route.query;
    const { token } = await this;
    await this.$http
      .get(`/api/result/data/${this.$route.params.id}/?lang=${lang || 'sv'}`)
      .then(response => response.data)
      .then(async (response) => {
        this.data = response;
        let price = 0;
        const data = [];
        await response.products.forEach((el) => {
          el.products.forEach((item) => {
            const obj = item;
            obj.product_type = el.title;
            data.push(obj);
            price += obj.price;
          });
        });
        this.products = data;
        this.texts = response.texts;
        this.price = price;
      });


    this.$http
      .post(
        '/api/cart/code/',
        { id: this.$route.params.id },
        {
          headers: {
            Authorization: token,
          },
        },
      )
      .then(response => response.data)
      .then(async ({ code, status }) => {
        this.discountCode = code;
        this.discountCodestatus = status === 'used';
      });
  },
};
</script>
